import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'

type ModalProps = {
  openModalGiftCard: boolean
  setOpenModalGiftCard: React.Dispatch<React.SetStateAction<boolean>>
  mainMessage?: string
  subMessage?: string
  buttonLabel?: string
  cancelLabel?: string
  onClearCart?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function ModalGiftCard({
  openModalGiftCard,
  setOpenModalGiftCard,
  mainMessage,
  subMessage,
  buttonLabel,
  cancelLabel,
  onClearCart,
}: ModalProps) {
  useEffect(() => {
    if (typeof document === 'undefined' || !document?.body?.style) {
      return
    }

    if (openModalGiftCard) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [openModalGiftCard])

  if (!openModalGiftCard) {
    return null
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[10001] flex items-center justify-center bg-black bg-opacity-40 w-screen h-screen"
      onClick={() => setOpenModalGiftCard(false)}
      onKeyDown={(e) => e.key === 'Escape' && setOpenModalGiftCard(false)}
      role="button"
      tabIndex={0}
      aria-label="Fechar modal"
    >
      <div
        className="bg-white rounded-2xl shadow-lg w-[340px] h-[475px] flex flex-col justify-between py-8 px-6"
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        {/* Mensagens principais */}
        <div>
          <div className="px-3">
            <p className="text-center text-[#101010] text-base font-medium leading-6 mb-4 mt-7">
              {mainMessage}
            </p>
            <p className="text-center text-[#101010] text-base font-medium leading-6 mb-8 mt-6">
              {subMessage}
            </p>
          </div>

          {/* Botão principal */}
          <button
            onClick={(e) => onClearCart?.(e)}
            className="w-full border border-[#101010] bg-[#101010] text-white rounded-full py-3 text-base font-semibold mb-3 hover:bg-[#2C2C2C] transition"
          >
            {buttonLabel}
          </button>

          {/* Botão cancelar */}
          <button
            onClick={() => setOpenModalGiftCard(false)}
            className="w-full border border-[#E1E0DF] text-[#101010] rounded-full py-3 text-base font-semibold mb-4 hover:bg-[#F8F8F8] transition"
          >
            {cancelLabel}
          </button>
        </div>

        {/* Mensagem informativa */}
        <p className="text-sm text-[#616161] text-center leading-relaxed">
          Caso queira comprar maiores quantidades, visite nosso{' '}
          <FlexibleLink
            linkUrl="https://www.decathlonpro.com.br/"
            target="_blank"
            classNames="underline"
            label="site para empresas"
          />
          .
        </p>
      </div>
    </div>,
    document.body
  )
}

export default ModalGiftCard
